
(function () {
  function getNumber(id, optional = false) {
    const field = document.getElementById(id);
    if (!field) return NaN;

    const value = field.value.trim();
    if (value === "") return optional ? 0 : NaN;

    return Number(value);
  }

  function calculatePotency() {
    const flowerWeight = getNumber("flowerWeight");
    const thcPercentage = getNumber("thcPercentage", true);
    const cbdPercentage = getNumber("cbdPercentage", true);
    const mediumVolume = getNumber("mediumVolume");
    const medium = document.getElementById("medium").value;

    if (
      !Number.isFinite(flowerWeight) || flowerWeight <= 0 ||
      !Number.isFinite(mediumVolume) || mediumVolume <= 0 ||
      !Number.isFinite(thcPercentage) ||
      !Number.isFinite(cbdPercentage) ||
      thcPercentage < 0 || thcPercentage > 100 ||
      cbdPercentage < 0 || cbdPercentage > 100 ||
      thcPercentage + cbdPercentage > 100
    ) {
      alert("Please enter valid flower weight, volume, and percentages.");
      return;
    }

    if (thcPercentage === 0 && cbdPercentage === 0) {
      alert("Please enter at least one THC or CBD percentage.");
      return;
    }

    const volumeMl = mediumVolume * 236.588;
    const totalTHC = flowerWeight * thcPercentage * 10;
    const totalCBD = flowerWeight * cbdPercentage * 10;

    const thcPerMl = totalTHC / volumeMl;
    const cbdPerMl = totalCBD / volumeMl;

    const result = document.getElementById("potencyResult");

    let html = "<h3>Infusion Potency Results</h3>";
    html += "<strong>Medium:</strong> " + medium + "<br>";

    if (thcPercentage > 0) {
      html += "<strong>Total THC:</strong> " +
        totalTHC.toFixed(2) + " mg<br>";
      html += "<strong>THC Potency:</strong> " +
        thcPerMl.toFixed(2) + " mg/mL<br>";
    }

    if (cbdPercentage > 0) {
      html += "<strong>Total CBD:</strong> " +
        totalCBD.toFixed(2) + " mg<br>";
      html += "<strong>CBD Potency:</strong> " +
        cbdPerMl.toFixed(2) + " mg/mL<br>";
    }

    result.innerHTML = html;

    document.getElementById("oilTHC").value =
      thcPerMl > 0 ? thcPerMl.toFixed(6) : "";

    document.getElementById("oilCBD").value =
      cbdPerMl > 0 ? cbdPerMl.toFixed(6) : "";

    document.getElementById("servingResult").innerHTML = "";
  }

  function calculateServings() {
    const thcPerMl = getNumber("oilTHC", true);
    const cbdPerMl = getNumber("oilCBD", true);
    const totalMedium = getNumber("totalMedium");
    const unit = document.getElementById("mediumUnit").value;
    const servings = getNumber("servings");

    if (
      !Number.isFinite(thcPerMl) || thcPerMl < 0 ||
      !Number.isFinite(cbdPerMl) || cbdPerMl < 0
    ) {
      alert("Please enter valid THC or CBD potency.");
      return;
    }

    if (thcPerMl === 0 && cbdPerMl === 0) {
      alert("Please enter THC or CBD potency in mg/mL.");
      return;
    }

    if (
      !Number.isFinite(totalMedium) || totalMedium <= 0 ||
      !Number.isSafeInteger(servings) || servings <= 0
    ) {
      alert("Please enter a valid recipe amount and number of servings.");
      return;
    }

    const conversions = {
      ml: 1,
      tsp: 4.92892,
      tbsp: 14.7868,
      cup: 236.588
    };

    const volumeMl = totalMedium * conversions[unit];
    const totalTHC = thcPerMl * volumeMl;
    const totalCBD = cbdPerMl * volumeMl;

    let html = "<h3>Recipe Potency Results</h3>";

    if (thcPerMl > 0) {
      html += "<strong>Total THC in Recipe:</strong> " +
        totalTHC.toFixed(2) + " mg<br>";
    }

    if (cbdPerMl > 0) {
      html += "<strong>Total CBD in Recipe:</strong> " +
        totalCBD.toFixed(2) + " mg<br>";
    }

    html += "<h3>Potency Per Serving</h3>";

    if (thcPerMl > 0) {
      html += '<div class="cf-highlight">THC: ' +
        (totalTHC / servings).toFixed(2) +
        " mg per serving</div>";
    }

    if (cbdPerMl > 0) {
      html += '<div class="cf-highlight">CBD: ' +
        (totalCBD / servings).toFixed(2) +
        " mg per serving</div>";
    }

    document.getElementById("servingResult").innerHTML = html;
  }

  function initializeCalculator() {
    const calculator = document.getElementById("cannafuse-calculator");
    if (!calculator) return;

    const buttons = calculator.querySelectorAll("button");

    buttons.forEach(function (button) {
      if (button.textContent.includes("Calculate Infusion Potency")) {
        button.addEventListener("click", calculatePotency);
      }

      if (button.textContent.includes("Calculate Potency Per Serving")) {
        button.addEventListener("click", calculateServings);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCalculator);
  } else {
    initializeCalculator();
  }
})();



/* CannaFuse label printing v3 - replace ONLY previous printing section */
(function () {
  "use strict";
  const sizes = {"2x1":[2,1],"3x2":[3,2],"4x3":[4,3],"6x4":[6,4]};
  const $ = id => document.getElementById(id);
  const val = id => ($(id) ? $(id).value.trim() : "");
  const num = id => Number(val(id) || 0);
  const fmt = n => Number(n.toFixed(2)).toString();
  function make(doc, tag, text, cls) {
    const el = doc.createElement(tag);
    if (text !== undefined && text !== null) el.textContent = String(text);
    if (cls) el.className = cls;
    return el;
  }
  function detailsFor(type) {
    if (type === "infusion") {
      const g=num("flowerWeight"), t=num("thcPercentage"), c=num("cbdPercentage"), cups=num("mediumVolume"), ml=cups*236.588;
      if (!(g>0 && ml>0 && t>=0 && c>=0 && t<=100 && c<=100 && t+c<=100 && t+c>0)) return null;
      return {type:"INFUSION",unit:"mg/mL",thc:g*t*10/ml,cbd:g*c*10/ml,
        quick:[`${fmt(g)} g flower`,`${fmt(cups)} cup${cups===1?"":"s"} ${val("medium")}`],
        details:[["Flower",`${fmt(g)} g`],["THC / CBD",`${fmt(t)}% / ${fmt(c)}%`],["Medium",val("medium")],["Volume",`${fmt(cups)} cups`],["Total THC",`${fmt(g*t*10)} mg`],["Total CBD",`${fmt(g*c*10)} mg`]]};
    }
    const t=num("oilTHC"),c=num("oilCBD"),amount=num("totalMedium"),servings=num("servings"),unit=val("mediumUnit");
    const factors={ml:1,tsp:4.92892,tbsp:14.7868,cup:236.588};
    if (!(t>=0 && c>=0 && t+c>0 && amount>0 && Number.isSafeInteger(servings) && servings>0 && factors[unit])) return null;
    const total=amount*factors[unit];
    return {type:"RECIPE",unit:"mg",thc:t*total/servings,cbd:c*total/servings,
    quick:[`Total recipe yield: ${servings} servings`,`Infusion used in entire recipe: ${fmt(amount)} ${unit}`],
      details:[["THC / CBD oil",`${fmt(t)} / ${fmt(c)} mg/mL`],["Infusion used",`${fmt(amount)} ${unit}`],["Total recipe yield",`${servings} servings`],["Total THC",`${fmt(t*total)} mg`],["Total CBD",`${fmt(c*total)} mg`]]};
  }
  function print(type, nameInput, sizeSelect, formatSelect) {
    const result=$(type==="infusion"?"potencyResult":"servingResult");
    if (!result || !result.textContent.trim()) { alert("Calculate the potency before printing."); return; }
    const data=detailsFor(type);
    if (!data) { alert("Check your entries and calculate again."); return; }
    const dimensions=sizes[sizeSelect.value];
    if (!dimensions) return;
    const [w,h]=dimensions;
    const tiny=sizeSelect.value==="2x1", small=sizeSelect.value==="3x2";
    const paper=formatSelect.value==="paper";
    const name=nameInput.value.trim() || (type==="infusion"?"Untitled Infusion":"Untitled Recipe");
    const win=window.open("","_blank","width=800,height=650");
    if (!win) { alert("Please allow pop-ups for printing."); return; }
    const doc=win.document;
    doc.open(); doc.write("<!doctype html><html><head><meta charset='utf-8'><title>CannaFuse Label</title></head><body></body></html>"); doc.close();
    const style=make(doc,"style");
    style.textContent=`
      @page { size: ${paper?"letter":`${w}in ${h}in`}; margin: 0; }
      * { box-sizing:border-box; }
      html,body { margin:0; padding:0; background:#fff; color:#000; font-family:Arial,Helvetica,sans-serif; }
      body { ${paper?"width:8.5in;height:11in;display:flex;align-items:center;justify-content:center;":""} }
      .label { width:${w}in;height:${h}in;padding:${tiny?"0.07in 0.055in 0.07in 0.20in":small?"0.10in":"0.15in"};;border:${paper?"2px solid #000":"0"};display:flex;flex-direction:column;overflow:hidden;break-inside:avoid; }
      .top { display:flex;align-items:baseline;justify-content:space-between;gap:5px;border-bottom:2px solid #000;padding-bottom:${tiny?"2px":"5px"}; }
      .brand { font-size:${tiny?"11px":small?"17px":"24px"};font-weight:900;letter-spacing:-0.4px; }
      .type { font-size:${tiny?"7px":small?"9px":"12px"};font-weight:800; }
      .name { font-size:${tiny?"11px":small?"18px":"26px"};font-weight:900;line-height:1.07;margin:${tiny?"3px 0":"8px 0"};overflow-wrap:anywhere;max-height:${tiny?"24px":small?"42px":"65px"};overflow:hidden; }
      .main { display:flex;align-items:stretch;gap:${tiny?"8px":"12px"};flex:1;min-height:0; }
      .values { display:flex;gap:${tiny?"8px":"12px"};flex:${tiny?"1":"1.15"};align-items:center; }
      .value { flex:1;min-width:0; }
      .key { font-size:${tiny?"7px":small?"10px":"12px"};font-weight:900; }
      .potency-line { display:flex;align-items:baseline;gap:4px;white-space:nowrap; }
      .number { font-size:${tiny?"15px":small?"24px":"36px"};font-weight:900;line-height:1.05;white-space:nowrap; }
      .unit { font-size:${tiny?"7px":small?"9px":"12px"};font-weight:800;white-space:nowrap; }
      .info { flex:0.85;border-left:2px solid #000;padding-left:10px;display:flex;flex-direction:column;justify-content:center;gap:5px;font-size:${small?"10px":"13px"};font-weight:700; }
      .info div { overflow-wrap:anywhere; }
      .detailgrid { display:grid;grid-template-columns:1fr 1fr;gap:6px 14px;margin-top:7px;font-size:${w===4?"11px":"15px"}; }
      .detail { display:flex;justify-content:space-between;gap:8px;border-bottom:1.5px solid #000;padding-bottom:3px; }
      .detail strong { text-align:right; }
      .disclaimer { font-size:${w===4?"9px":"12px"};font-weight:700;margin-top:7px; }
      .bottom { display:flex;justify-content:space-between;gap:5px;align-items:baseline;margin-top:auto;border-top:2px solid #000;padding-top:${tiny?"2px":"5px"};font-size:${tiny?"7px":small?"10px":"13px"};font-weight:800; }
      .bottom span:first-child { white-space:nowrap; }
      @media print { html,body { -webkit-print-color-adjust:exact;print-color-adjust:exact; } }
    `;
    doc.head.appendChild(style);
    const label=make(doc,"div",null,"label");
    const top=make(doc,"div",null,"top");
    top.append(make(doc,"span","CannaFuse","brand"),make(doc,"span",data.type+" POTENCY","type"));
    label.appendChild(top);
    label.appendChild(make(doc,"div",name,"name"));
    const main=make(doc,"div",null,"main");
    const values=make(doc,"div",null,"values");
    const potencyEntries=[["THC",data.thc],["CBD",data.cbd]].filter(item=>item[1]>0);
    potencyEntries.forEach(([key,value])=>{
      const block=make(doc,"div",null,"value");
    const potencyLine=make(doc,"div",null,"potency-line");
potencyLine.append(make(doc,"span",fmt(value),"number"),make(doc,"span",data.unit,"unit"));
block.append(make(doc,"div",type==="recipe"?key+" PER SERVING":key,"key"),potencyLine);
      values.appendChild(block);
    });
    main.appendChild(values);
    if (!tiny) {
      const info=make(doc,"div",null,"info");
      data.quick.forEach(line=>info.appendChild(make(doc,"div",line)));
      main.appendChild(info);
    }
    label.appendChild(main);
    if (!tiny && !small) {
      const grid=make(doc,"div",null,"detailgrid");
      data.details.forEach(([k,v])=>{
        const row=make(doc,"div",null,"detail");
        row.append(make(doc,"span",k),make(doc,"strong",v));
        grid.appendChild(row);
      });
      label.appendChild(grid);
      label.appendChild(make(doc,"div","Estimated potency; not laboratory verified. Actual results vary with processing and mixing.","disclaimer"));
    }
    const bottom=make(doc,"div",null,"bottom");
    bottom.append(make(doc,"span","cannafusepouch.com"),make(doc,"span",new Date().toLocaleDateString()));
    label.appendChild(bottom);
    doc.body.appendChild(label);
    win.focus();
    setTimeout(()=>win.print(),500);
  }
  function setup() {
    if (!$('cannafuse-calculator')) return;
    [["infusion","potencyResult","Infusion"],["recipe","servingResult","Recipe"]].forEach(([type,resultId,title])=>{
      const result=$(resultId);
      if (!result || $("print-"+type)) return;
      const panel=make(document,"div");
      panel.style.cssText="margin-top:20px;padding:15px;border:1px solid #ccc;border-radius:8px;";
      const label=make(document,"label",title+" Name:");
      label.style.display="block";
      const name=document.createElement("input");
      name.type="text";name.id="name-"+type;name.placeholder="Enter a name";
      name.style.cssText="display:block;width:100%;margin:6px 0 12px;";
      const sizeLabel=make(document,"label","Label Size:");
      sizeLabel.style.display="block";
      const size=document.createElement("select");
      size.id="label-size-"+type;
      [["2x1","2 × 1 inches — tincture"],["3x2","3 × 2 inches — small"],["4x3","4 × 3 inches — medium"],["6x4","6 × 4 inches — large"]].forEach(([value,text])=>{
        const option=document.createElement("option");option.value=value;option.textContent=text;size.appendChild(option);
      });
      size.value="3x2";size.style.cssText="display:block;width:100%;padding:8px;margin:6px 0 12px;";
      const formatLabel=make(document,"label","Print Format:");
      formatLabel.style.display="block";
      const format=document.createElement("select");
      [["thermal","Thermal / label printer (exact size)"],["paper","Regular printer (US Letter, cut out label)"]].forEach(([value,text])=>{
        const option=document.createElement("option");option.value=value;option.textContent=text;format.appendChild(option);
      });
      format.style.cssText="display:block;width:100%;padding:8px;margin:6px 0 12px;";
      const button=document.createElement("button");button.type="button";button.id="print-"+type;
      button.textContent="Print "+title+" Label";
      button.addEventListener("click",()=>print(type,name,size,format));
      panel.append(label,name,sizeLabel,size,formatLabel,format,button);
      result.insertAdjacentElement("afterend",panel);
    });
  }
  if (document.readyState==="loading") document.addEventListener("DOMContentLoaded",setup);
  else setup();
})();
